export const FETCH_CLIENT = "FETCH_CLIENT";
export const FETCH_CLIENT_SUCCESS = "FETCH_CLIENT_SUCCESS";
export const FETCH_CLIENT_FAILURE = "FETCH_CLIENT_FAILURE";

export const CREATE_CLIENT_REQUEST = "CREATE_CLIENT_REQUEST";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const CREATE_CLIENT_FAILURE = "CREATE_CLIENT_FAILURE";

export const CHANGE_CLIENT_STATUS = "CHANGE_CLIENT_STATUS";
export const CHANGE_CLIENT_STATUS_SUCCESS = "CHANGE_CLIENT_STATUS_SUCCESS";
export const CHANGE_CLIENT_STATUS_FAILURE = "CHANGE_CLIENT_STATUS_FAILURE";

export const DELETE_CLIENT = "DELETE_CLIENT";
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";
export const DELETE_CLIENT_FAILURE = "DELETE_CLIENT_FAILURE";

export const GENERATE_CLIENT_CODE = "GENERATE_CLIENT_CODE";
export const GENERATE_CLIENT_CODE_SUCCESS = "GENERATE_CLIENT_CODE_SUCCESS";
export const GENERATE_CLIENT_CODE_FAILURE = "GENERATE_CLIENT_CODE_FAILURE";

export const FETCH_ACTIVE_CLIENT_REQUEST = "FETCH_ACTIVE_CLIENT_REQUEST";
export const FETCH_ACTIVE_CLIENT_SUCCESS = "FETCH_ACTIVE_CLIENT_SUCCESS";
export const FETCH_ACTIVE_CLIENT_FAILURE = "FETCH_ACTIVE_CLIENT_FAILURE";
  
export const FETCH_TIMESHEET_GET_ACCOUNT_LIST = 'FETCH_TIMESHEET_GET_ACCOUNT_LIST_REQUEST';
export const FETCH_TIMESHEET_GET_ACCOUNT_LIST_SUCCESS = 'FETCH_TIMESHEET_GET_ACCOUNT_LIST_SUCCESS';
export const FETCH_TIMESHEET_GET_ACCOUNT_LIST_FAILURE = 'FETCH_TIMESHEET_GET_ACCOUNT_LIST_FAILURE';